import {
  buildHtml,
  buildLink,
  KitchenSinkRoute,
  RouteSlotInput,
} from '@luks/ui';

import { ParagraphOptions } from './AllParagraphs';

export const mapContextualText = (
  input: ContextualTextFragment,
  context: { payload?: ParagraphOptions },
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'ContextualTextSection'> => {
  return {
    key: 'ContextualTextSection',
    input: {
      title: input.title || '',
      Description: buildHtml(input.textHtml || ''),
      Link: buildLink({ href: input.link?.url }),
      linkText: input.link?.text || '',
      inSidebar: !!context.payload?.inSidebar,
    },
  };
};
